import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/models/simulation/Simulation';
import { BankDictionaryElement } from '@/modules/banks/models/BankDictionaryElement';
import { banksDictionary } from '@/commons/dictionaries/BanksDictionary';
import { BankSymbol } from '@/commons/dictionaries/BankSymbol';
import { computed } from 'vue';
import CalculatorSummary from '@/components/calculator/results/CalculatorSummary.vue';
import { useSimulationStore } from '@/components/calculator/services/SimulationStore';
import { useInstance } from '@/composables/useInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationFormInfoPanel',
  setup(__props) {

const simulationStore = useSimulationStore();
const { $env, } = useInstance();

const topOffers = computed<Nullable<Offer[]>>(() => {
  const TOP_OFFERS_COUNT = 3;
  return simulationStore.simulation?.offers.slice(0, TOP_OFFERS_COUNT) || null;
});

const bank = (bankSymbol: BankSymbol): Nullable<BankDictionaryElement> => {
  const bankDictionaryElement = banksDictionary().find(x => x.type === bankSymbol);
  if (bankDictionaryElement) {
    return bankDictionaryElement;
  } else {
    throw new Error('No bank found for offer ' + bankSymbol);
  }
}

return { __sfc: true,simulationStore, $env, topOffers, bank, CalculatorSummary }
}

})